import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import buildContextMenu from '../Common/BuildContextMenu';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import EventDialog from '../Event/EventDialog';

import DetailView from '../Common/DetailView';
import Timeline from 'react-calendar-timeline/lib';
import 'react-calendar-timeline/lib/Timeline.css';
import moment from 'moment';
import TrainerIcon from 'material-ui/svg-icons/social/person';
import ScheduleIcon from 'material-ui/svg-icons/communication/clear-all';
import CalendarIcon from 'material-ui/svg-icons/action/date-range';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';

import TrainerStore from '../../stores/TrainerStore';
import EventStore from '../../stores/EventStore';
import EventActions from '../../actions/EventActionCreator';
import UserActions from '../../actions/UserActionCreator';
import { formatName } from '../../utils/StringUtils';
import { statusColours } from '../../constants/ColourConstants';
import ROLES from '../../constants/Roles';

moment.updateLocale('en', { week: { dow: 1 }});

const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};

const getScheduleItem = (event => ({
    id: event.id,
    group: event.trainerId,
    title: event.name,
    start_time: moment(event.timeStart).valueOf(),
    end_time: moment(event.timeEnd).valueOf(),
}));

const getMenuItems = () => [
    {
        link: '/dashboard/trainers',
        icon: <TrainerIcon />,
        label: 'Trainers',
    },
    { type: 'divider' },
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    },
];

const groupRenderer = ({group}) =>  (
    <div className="schedule-group trainer">
        <Link to={`/dashboard/user/${group.id}`}><span className="title">{group.title}</span></Link>
        <p className="tip">{group.tip}</p>
    </div>
);

let timeout;

class TrainerSchedule extends Component {

    constructor() {
        super(...arguments);

        this.state = {
            events: [],
            trainers: [],
            selectedEvent: false,
            startDate: moment().startOf('week'),
            endDate: moment().endOf('week')
        };
    }

    componentWillMount() {
        this.onEventChange();
        this.onTrainerChange();
    }

    componentDidMount() {
        this.onEventChange = this.onEventChange.bind(this);
        this.onTrainerChange = this.onTrainerChange.bind(this);
        this.selectEvent = this.selectEvent.bind(this);

        this.listeners = [
            EventStore.addListener(this.onEventChange),
            TrainerStore.addListener(this.onTrainerChange),
        ];

        const limits = {
            startDate: this.state.startDate.clone().subtract(1, 'week').toISOString(true),
            endDate: this.state.endDate.clone().add(1, 'week').toISOString(true)
        };
        EventActions.getTrainersEvents(limits);
        UserActions.getTrainers();
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    }

    render() {
        return(
            <DetailView actions={buildContextMenu(getMenuItems(), this.context.auth)} >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title="Schedule"
                            subtitle={<Link to={`/dashboard/trainers`}>trainers</Link>}
                            avatar={<ScheduleIcon style={style.icon} color={statusColours.default} />}
                        />
                        <div className="cent-card-header-buttons">
                            <Link to={`/dashboard/trainers/events`}><CalendarIcon className='cent-icon' color={statusColours.default}/></Link>
                        </div>
                        <CardText className="cent-card-text">
                            <Timeline
                                headerLabelGroupHeight={40}
                                headerLabelHeight={40}
                                lineHeight={60}
                                groups={this.state.trainers}
                                items={this.state.scheduleItems}
                                sidebarContent=""
                                canMove={false}
                                canResize={false}
                                canChangeGroup={false}
                                defaultTimeStart={this.state.startDate}
                                defaultTimeEnd={this.state.endDate}
                                onItemClick={this.selectEvent}
                                onItemSelect={this.selectEvent}
                                stackItems={true}
                                onBoundsChange={this.onBoundsChange}
                                groupRenderer={groupRenderer}
                            />
                        </CardText>
                    </Card>
                </div>
                <EventDialog
                    event={this.state.selectedEvent}
                    onClose={() => this.selectEvent()}
                    editLink={ROLES.ADMIN && this.state.selectedEvent && `/dashboard/event/${this.state.selectedEvent.id}/edit`}
                />
            </DetailView>
        )
    }

    selectEvent(eventId) {
        const selectedEvent = !!eventId && this.state.events.find(({id}) => id === eventId);
        this.setState({selectedEvent});
    }

    onBoundsChange(canvasTimeStart, canvasTimeEnd) {
        const limits = {
            startDate: moment(canvasTimeStart).toISOString(),
            endDate: moment(canvasTimeEnd).toISOString(false)
        };
        timeout && clearTimeout(timeout);
        timeout = setTimeout(() => EventActions.getTrainersEvents(limits), 100);
    }

    onEventChange() {
        const events = EventStore.getTrainerEvents();
        if (!!events) {
            this.setState({events, scheduleItems: events.map(getScheduleItem)});
        }
    }

    onTrainerChange() {
        const trainers = TrainerStore.getAll();
        if (trainers !== undefined) {            
            this.setState({trainers: trainers.map(trainer => ({id: trainer.id, title: formatName(trainer)}))});
        }
    }
}

TrainerSchedule.contextTypes = {
    auth:       PropTypes.object
};

export default TrainerSchedule;
